export default __webpack_public_path__ + "static/media/bike-6.9f477d15.svg";